export function ValidateGlobalGoals(control) {
  const value = JSON.parse(control.value);
  if (!value) return { validGlobalGoalsNotComplete: true };
  if (value.goals.length === 0) {
    return { validGlobalGoalsNotComplete: true };
  }
}
